import { QueryClient } from '@tanstack/react-query';
import { esErrorApi } from './errores';

/**
 * Configuración de TanStack Query.
 *
 * **Reintentar no es gratis en este sistema.** Las lecturas se reintentan solo
 * si la falla puede ser transitoria; las escrituras (emitir un comprobante)
 * **nunca** se reintentan solas: quien reintenta una emisión es el usuario, con
 * la MISMA `Idempotency-Key`, que es lo que garantiza que no salgan dos
 * comprobantes fiscales por la misma operación. Un reintento automático con una
 * clave nueva sería justamente el peor bug posible del facturador.
 */
export function crearQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (intento, error) => {
          // Un 4xx no mejora reintentando: la credencial sigue siendo inválida
          // y el id sigue sin existir. Solo se reintenta lo que puede ser
          // transitorio (sin conexión, 5xx).
          if (esErrorApi(error) && error.estado >= 400 && error.estado < 500) {
            return false;
          }
          return intento < 2;
        },
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
